import React,{useEffect} from 'react';
import {btnSetColor_CBack,TableDatePicker} from '../../function_lib/common_lib';
import {Custom_Alert,Alert_Content} from '../../components/custom_alert';
export function Comp_Add_Bridge_Watch_Keeping_Records(props){
  //alert(JSON.stringify(props.editUser));
  const saveBridgeWatchKeeping=()=>{
    btnSetColor_CBack(this,"frmAddBridgeWatchkeeping","addBridgeWatchKeeping",function(data,msg){
        //alert(msg);
        Custom_Alert("View",msg,false);
    })
  }
   useEffect(()=>{

   },[props.editUser]);
  
    return(<div className="modal fade bd-example-modal-xl"  id="divAddBridgeWatchKeeRec" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xl" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">Bridge Watch Keeping Record </h5>
          <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
        <form id="frmAddBridgeWatchkeeping" name="frmAddBridgeWatchkeeping">
            <input type="hidden" id="m_type" name="m_type" value={"addBridgeWatchKeeping"}/>
            <input type="hidden" id="res_func" name="res_func" value={"useit"}/>
            <input type="hidden" id="global_token" name="global_token" value={props.logUser[0]["app_user_id"]}/>
            <input type="hidden" id="local_token" name="local_token" value={props.logUser[0]["id"]}/>
            
        <div className="modal-body">
             {/* form content  */}
             
             <div class="container port_bridge_watchkeepinggg text-start">
    <h2 class="text-center mb-4">Record of Bridge Watchkeeping Form</h2>
   
        <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Ship Name:</strong></label>
                <input name="ship_name" id="ship_name" type="text" class="form-control required" placeholder="Enter ship name" required/>
            </div>
            <div class="col-md-6 form-group">
                <label><strong>Ship Type:</strong></label>
                <input name="ship_type" id="ship_type" type="text" class="form-control required" placeholder="Enter ship type" required/>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>IMO Number:</strong></label>
                <input name="imo_no" id="imo_no" type="text" class="form-control required" placeholder="Enter imo number" required/>
            </div>
            
            <div class="col-md-6 form-group">
                <label><strong>Call sign:</strong></label>
                <input name="call_sign" id="call_sign" type="text" class="form-control required" placeholder="Enter Call sign" required/>
            </div>
        </div>

         <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Date:</strong></label>
                <div className="input-group input-group-sm">
                <TableDatePicker refName="watch_date" />
                </div>
                {/* <input name="watch_date" id="watch_date" type="watch_date" class="form-control" required/> */}
            </div>
            <div class="col-md-6 form-group">
                <label><strong>Time From:</strong></label>
                <input name="time_from" id="time_from" type="time" class="form-control" required/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Time To:</strong></label>
                <input name="time_to" id="time_to" type="time" class="form-control" required/>
            </div>
            <div class="col-md-6 form-group">
                <label><strong>Voyage Number:</strong></label>
                <input name="voyage_number" id="voyage_number" type="text" class="form-control" placeholder="Enter voyage number" required/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Voyage Description:<br/> (state departure & arrival ports)</strong></label>
                <textarea id="voyage_description" name="voyage_description" class="form-control"></textarea>
                {/* <input name="voyage_descrption" id="voyage_descrption" type="text" class="form-control" placeholder="Enter Voyage Description" required/> */}
            </div>
            <div class="col-md-6 form-group">
                <label><strong>Type of watch <br/> (sea/pilotage/anchorage):</strong></label>
                <select id="type_of_watch" name="type_of_watch" class="form-control">
                    <option value={"0"}>-Select-</option>
                    <option value={"sea"}>sea</option>
                    <option value={"pilotage"}>pilotage</option>
                    <option value={"anchorage"}>anchorage</option>

                </select>
                {/* <input name="height" type="number" class="form-control" placeholder="Enter remarks" required/> */}
            </div>
        </div>

       <div class="row">
        <div class="col-md-6 form-group">
                <label><strong>Remarks (describe watch activities):</strong></label>
                <textarea id="remarks" name="remarks" class="form-control required">

                </textarea>
                {/* <input name="remarks" type="number" class="form-control" placeholder="Enter remarks" required/> */}
            </div>
            {/* <div class="col-md-6 form-group">
                <label><strong>Signature of OOW  </strong></label>
                <input name="ow_signature" type="text" class="form-control" required/>
            </div> */}
       </div>

        {/* <div class="text-center mt-4">
            <button type="button" class="btn btn-primary me-2">Submit</button>
            <button type="reset" class="btn btn-secondary">Reset</button>
        </div> */}
    
</div>
             {/* end of form contacnt */}
        </div>
        <div className="modal-footer">
        <div id="getReponse" style={{color:"red"}}></div>
          <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" data-dismiss="modal">Close</button>
          <button type="button" className="btn btn-primary" onClick={()=>saveBridgeWatchKeeping()}>Save</button>
        </div>
        </form>
      </div>
      </div>
      </div>)
}

export default Comp_Add_Bridge_Watch_Keeping_Records;